export enum FileExtensions{
    CSV = 'csv',
    Excel = 'xls',
    ExcelModern = 'xlsx',
    PDF = 'pdf',
    PNG = 'png',
    JPG = 'jpg',
    JPEG = 'jpeg',
    GIF = 'gif',
    MSG = 'msg'
}